import React from 'react';

export default function SectionHeading({ id, children, description }) {
  return (
    <div className="section-heading">
      <h2 id={id}>{children}</h2>
      {description ? <p>{description}</p> : null}
    </div>
  );
}
